import fuzzy from 'fuzzy'

const mixin = {
  data() {
    return {
      itemSearchTerm: '',
      searchTermDebounced: '',
      updateSearchTerm: _.debounce(v => (this.searchTermDebounced = v), 200)
    }
  },
  computed: {
    // Define as computed property so it can be overridden as such to provide persisting backing field
    searchTerm: {
      get() {
        return this.itemSearchTerm || ''
      },
      set(v) {
        this.itemSearchTerm = v
      }
    },

    items() {
      return [] // Override in consuming component
    },
    filteredItems() {
      if (!this.searchTermDebounced) {
        return _.orderBy(this.items, 'name').map(t => ({
          string: this.toHighlightedHtml(this.filterExtract(t)),
          original: t
        }))
      } else {
        const filterOptions = {
          pre: '__START__',
          post: '__END__',
          extract: t => this.filterExtract(t)
        }
        const fuzzyResults = fuzzy
          .filter(this.searchTermDebounced, this.items, filterOptions)
          .map(item => {
            item.string = this.toHighlightedHtml(item.string || '')
            return item
          })
        // Optimization: if search string is too short to be an id, skip the by-id traversal
        if (this.searchTermDebounced.length < 6) return fuzzyResults
        // Could be an id. Match by that too
        return this.items
          .filter(i => this.idExtract(i) === this.searchTermDebounced)
          .map(i => ({
            string: this.filterExtract(i),
            original: i
          }))
          .concat(fuzzyResults)
      }
    }
  },

  methods: {
    filterExtract(item) {
      return item.name
    },
    idExtract(item) {
      return item.id
    },
    toHighlightedHtml(text) {
      // Make sure any html-like content is not interpreted when rendered - except for the highlights
      return text
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/__START__/g, '<span class="match-highlight">')
        .replace(/__END__/g, '</span>')
    }
  },

  watch: {
    searchTerm(newTerm) {
      this.updateSearchTerm(newTerm)
    }
  },
  created() {
    this.searchTermDebounced = this.searchTerm
  }
}

export default mixin
